import { useQuery } from "@tanstack/react-query";
import { PARAMS } from "./endpoints";
import { getRequest } from "./axiosClient";

export const useGetParams = () => {
	return useQuery({
		queryKey: ["params"],
		queryFn: () => getRequest(PARAMS),
		retry: 1,
		refetchInterval: 60000,
	});
};
